<template>
  <b-modal
    id="freightModal" 
    ref="freightModal" 
    no-close-on-backdrop
    centered
    v-model="showAddRuleModal" 
    :title="isUpdate ? 'Atualizar Regra de Frete' : 'Adicionar Regra de Frete'" 
    hide-footer
  >
    <b-row>
      <b-col cols="12" md="6">
        <b-form>
          <b-form-group label="Tipo de Frete:" label-for="freight-type">
            <b-form-select
              id="freight-type"
              v-model="fields.type"
              :options="optionsFreight"
              @change="handleFreightTypeChange"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col cols="12" md="6">
        <b-form>
          <label>Valor do Frete R$:</label>
          <InputMoney
            v-model="fields.value"
            :disabled="fields.type === TypeFreight.FREE"
          />
        </b-form>
      </b-col>
      <b-col cols="12" md="6">
        <b-form>
          <b-form-group label="Km Inicial(De):" label-for="km-start">
            <b-form-input id="km-start" type="number" v-model.number="fields.kmStart" required></b-form-input>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col cols="12" md="6">
        <b-form>
          <b-form-group label="Km Final(Até):" label-for="km-end">
            <b-form-input id="km-end" type="number" v-model.number="fields.kmEnd" required></b-form-input>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" md="6">
        <b-button @click="closeModal()" variant="outline-danger" block>Cancelar</b-button>
      </b-col>
      <b-col cols="12" md="6">
        <b-button v-if="!isUpdate" @click="addRule()" variant="success" block>Salvar</b-button>
        <b-button v-else @click="updateRule()" variant="success" block>Atualizar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import InputMoney from '@/components/Inputs/InputMoney.vue';
import TypeFreight from '@/enums/TypeFreight';

export default {
  name: 'FreightModal',
  emits: ['save', 'update'],
  components: {
    InputMoney,
  },
  props: {
    lastRuleKm: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {
      TypeFreight,
      loading: false,
      optionsFreight: [
        { 
          text: 'Fixo', 
          value: 1
        },
        { 
          text: 'Km', 
          value: 2 
        },
        { 
          text: 'Grátis', 
          value: 3 
        },
      ],
      showAddRuleModal: false,
      freightRules: [],
      isUpdate: false,
      fields: {
        type: 1,
        value: 0,
        kmStart: 0,
        kmEnd: 0,
      },
    };
  },
  methods: {
    toggleOpen({ rulesData = null }) {
      this.resetNewRule();
      
      this.showAddRuleModal = !this.showAddRuleModal;

      if(rulesData !== null) {
        this.isUpdate = true;
        this.fields.type = rulesData.shipping_rule_type_id;
        this.fields.value = rulesData.value;
        this.fields.kmStart = rulesData.km_initial;
        this.fields.kmEnd = rulesData.km_final
      }
    },
    validation() {
      const valueMoney = this.parseMoney(this.fields.value);

      if(this.fields.type !== TypeFreight.FREE && valueMoney === 0) {
        this.$bvToast.toast('Valor tem que ser maior que 0', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      if (this.fields.kmStart === null || this.fields.kmEnd === null) {
        this.$bvToast.toast('Preencha todos os campos.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      if (this.fields.kmStart >= this.fields.kmEnd) {
        this.$bvToast.toast('Km Inicial deve ser menor ou igual ao Km Final.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      if (this.lastRuleKm > 0 && this.fields.kmStart <= this.lastRuleKm) {
        this.$bvToast.toast('Km Inicial não pode ser menor ou igual ao Km Final da regra anterior.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }
      return true;
    },
    addRule() {
      if(this.validation() === false) return;

      const data = {
        'type': this.fields.type,
        'value': this.fields.type === TypeFreight.FREE ? 0 : this.parseMoney(this.fields.value),
        'km_initial': this.fields.kmStart,
        'km_final': this.fields.kmEnd,
      }

      this.$emit('save', data);
      this.closeModal();
    },
    updateRule() {
      if(this.validation() === false) return;
      
      const data = {
        'type': this.fields.type,
        'value': this.fields.type === TypeFreight.FREE ? 0 : this.parseMoney(this.fields.value),
        'km_initial': this.fields.kmStart,
        'km_final': this.fields.kmEnd,
      }

      this.$emit('update', data);
      // this.closeModal();
    },
    handleFreightTypeChange(){
      if(this.fields.type === TypeFreight.FIXED || this.fields.type === TypeFreight.FREE){
        this.fields.kmStart = 0;
      }
    },
    closeModal() {
      this.showAddRuleModal = !this.showAddRuleModal;
    },
    resetNewRule(){
      this.fields.type = 1;
      this.fields.value = 0;
      this.fields.kmStart = 0;
      this.fields.kmEnd = 0;
      this.isUpdate = false;
    },
    parseMoney(moneyString) {
      if (!moneyString) return 0; // Handle empty or null strings

      // Remove "R$", thousands separators, and replace comma with dot
      const cleanedString = moneyString
        .replace('R$', '')
        .replace(/\./g, '') // Remove dots (thousands separators)
        .replace(',', '.'); // Replace comma with dot (decimal separator)

      // Convert to a number
      const number = parseFloat(cleanedString);

      return isNaN(number) ? 0 : number; // Handle cases where parsing fails
    }
  },
};
</script>
